export var Environment;
(function (Environment) {
  Environment["DEV"] = "DEV";
  Environment["NON_PROD"] = "NON_PROD";
  Environment["PROD"] = "PROD";
})(Environment || (Environment = {}));